import Image from 'next/image';
import Link from 'next/link';

import { fireClickZaloWidgetEvent } from '@utils/gtmUtils';

import style from './ZaloWidget.module.less';
import { getWarrantyPageRoute } from '@utils/routeConstants';
import { useRouter } from 'next/router';

const ZALO_AOID = process.env.NEXT_PUBLIC_ZALO_OAID;

function ZaloChatWidget() {
  const router = useRouter();
  const currentPath = router.pathname;
  const arrayHideZaloIcon = [getWarrantyPageRoute('tich-diem-hoa-don')];

  if (arrayHideZaloIcon.includes(currentPath)) {
    return <></>;
  }

  return (
    <div className={style.root} onClick={() => fireClickZaloWidgetEvent()}>
      <Link href={`https://zalo.me/${ZALO_AOID}`} style={{ position: 'relative' }}>
        <a target="_blank">
          <Image src="/images/zalo-widget.svg" width={60} height={60} />
        </a>
      </Link>
    </div>
  );
}

export default ZaloChatWidget;
